import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    black: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2f/f2f_Mblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2f/f2f_Mnavy_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2f/f2f_Mwhite_{nnn}.png',
    },
    neonblue: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2f/f2f_Mneon_{nnn}.png',
    },
    neonpink: {
      pathTemplate: 'gs://sg360/260311/42f_Ineonpink--{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/42f_Iglacierblue--{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/f2le_clear_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-6/f2le/f2le_gold_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/f2le_silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/f2le_smoke_{nnn}.png',
    },
    plum: {
      pathTemplate: 'gs://sg360/260903/42le_8plum--{nnn}.png',
    },
    IRgold: {
      pathTemplate: 'gs://sg360/260903/42le_8IRgold--{nnn}.png',
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/f2le_IRsmoke_{nnn}.png',
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/f2le_IRHVblue_{nnn}.png',
    },
  },
}

export const logos = {
  id: 'logos',
  name: 'Logos',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bgold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bgunmetal_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bsilver_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Brosegold_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bwhite_{nnn}.png',
    },
    BIsilver: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2i/f2i_Bsilvericon_{nnn}.png',
    },
    Bneonpink: {
      pathTemplate: 'gs://sg360/260311/pli_Bneonpink--{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  name: 'Reflections',
  isReflection: true,
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2le/f2le_IRsmoke_{nnn}-overlay.png',
      maxOpacity: 1,
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-4/f2le/f2le_IRHVblue_{nnn}-overlay.png',
      maxOpacity: 0.4,
    },
    IRgold: {
      pathTemplate: 'gs://sg360/260903/42le_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250502/forty2s-preview-5/f2le/shadow_{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    logos: customisedProduct.iconChoice?.sku?.split('_')?.slice(1)?.join('_'),
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    reflections: 'none',
  }
}

export default {
  supports360: false,
  layers: [background, frame, logos, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
